import { useQuery } from "@tanstack/react-query";
import { useQueryUserId } from "../lib/query";
import { drokRpc } from "./rpc";

/** loading: not known yet. manage-agents: IT, or enforcement is off. employee: everyone else, and any failed load. */
export type DrokAccessState = "loading" | "manage-agents" | "employee";

/** Keyed by user, so signing in as someone else loads again instead of reusing the last user's answer. */
export function drokAccessKey(userId: string | null) {
  return ["drok", `user:${userId ?? ""}`, "access.me"] as const;
}

/**
 * Whether the signed-in user manages agents. Loaded once per signed-in user. A failed load counts
 * as employee, so the UI fails closed while chat keeps working; the server checks stay authoritative.
 */
export function useDrokAccess(): DrokAccessState {
  const userId = useQueryUserId();
  const query = useQuery({
    queryKey: drokAccessKey(userId),
    queryFn: () => drokRpc.access.me(),
    enabled: userId !== null,
    staleTime: Number.POSITIVE_INFINITY,
    refetchOnMount: false,
  });
  if (userId === null || query.isPending) return "loading";
  if (query.isError) return "employee";
  return query.data.canManageAgents ? "manage-agents" : "employee";
}
